interface VibeMomLogoProps {
  size?: number; // высота в px, ширина пропорционально
}

export function VibeMomLogo({ size = 68 }: VibeMomLogoProps) {
  const width = Math.round(size * (80 / 90));
  return (
    <svg width={width} height={size} viewBox="0 0 80 90" fill="none">
      <defs>
        <linearGradient id="vmH" x1="40" y1="18" x2="40" y2="78" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#b794f6"/>
          <stop offset="40%" stopColor="#9b6dfa"/>
          <stop offset="75%" stopColor="#a855f7"/>
          <stop offset="100%" stopColor="#d07af0"/>
        </linearGradient>
        <linearGradient id="vmSh" x1="26" y1="22" x2="42" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="rgba(255,255,255,0.3)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </linearGradient>
        <radialGradient id="vmSd" cx="40" cy="78" r="16" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="rgba(180,100,247,0.3)"/>
          <stop offset="100%" stopColor="rgba(180,100,247,0)"/>
        </radialGradient>
        <linearGradient id="vmW" x1="24" y1="6" x2="56" y2="6" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#9b6dfa"/>
          <stop offset="50%" stopColor="#b794f6"/>
          <stop offset="100%" stopColor="#9b6dfa"/>
        </linearGradient>
      </defs>
      {/* WiFi arcs — ВЫШЕ сердца, за его пределами */}
      <path d="M22 16 C30 4 50 4 58 16" stroke="url(#vmW)" strokeWidth="4.5" fill="none" strokeLinecap="round"/>
      <path d="M28 24 C33 15 47 15 52 24" stroke="url(#vmW)" strokeWidth="4" fill="none" strokeLinecap="round"/>
      {/* Тень */}
      <ellipse cx="40" cy="78" rx="16" ry="4" fill="url(#vmSd)"/>
      {/* Сердце */}
      <path d="M40 72 C40 72 14 54 14 36 C14 26 22 20 30 20 C35 20 38 22.5 40 26 C42 22.5 45 20 50 20 C58 20 66 26 66 36 C66 54 40 72 40 72Z" fill="url(#vmH)"/>
      {/* Блик */}
      <path d="M40 72 C40 72 14 54 14 36 C14 26 22 20 30 20 C35 20 38 22.5 40 26 C42 22.5 45 20 50 20 C58 20 66 26 66 36 C66 54 40 72 40 72Z" fill="url(#vmSh)"/>
      {/* Блик-овал */}
      <ellipse cx="29" cy="34" rx="5" ry="8" fill="rgba(255,255,255,0.13)" transform="rotate(-15 29 34)"/>
    </svg>
  );
}
